/**
 * Para onde mandar quem quer baixar o app.
 *
 * Modulo puro: decide, nao navega.
 *
 * A escolha e por PLATAFORMA e nao um link so porque link de loja errada e pior
 * que nenhum: quem esta no iPhone e recebe a Play nao consegue instalar, e a
 * Apple nao gosta de app que aponta para outra loja.
 *
 * Dentro do app nativo nao ha o que oferecer — a pessoa ja esta nele.
 */

export const LINK_IOS = 'https://apps.apple.com/br/app/id6803204676';
export const LINK_ANDROID = 'https://play.google.com/store/apps/details?id=br.com.demiplie.metria';

/**
 * @param {{ nativo?: boolean, userAgent?: string }} ctx
 * @returns {{ loja: 'ios'|'android'|'ambas'|null, url: string|null }}
 *   `ambas` = desktop, onde nao da para adivinhar o aparelho dela.
 *   `null`  = ja esta no app, nao ha o que recomendar.
 */
export function lojaRecomendada({ nativo = false, userAgent = '' } = {}) {
  if (nativo) return { loja: null, url: null };

  const ua = String(userAgent || '').toLowerCase();
  // iPad moderno se anuncia como Mac; o toque no ponteiro e o que separa.
  const ehIOS = /iphone|ipad|ipod/.test(ua)
    || (/macintosh/.test(ua) && typeof document !== 'undefined' && 'ontouchend' in document);
  if (ehIOS) return { loja: 'ios', url: LINK_IOS };
  if (/android/.test(ua)) return { loja: 'android', url: LINK_ANDROID };

  // Desktop: mostra os dois e deixa ela escolher pelo aparelho que tem no bolso.
  return { loja: 'ambas', url: null };
}
